import {ChessPiece} from "./chessPiece";
import {KING_BLACK, KING_WHITE} from "./svg";

export class King extends ChessPiece {
    name = 'king';

    svgWhite = KING_WHITE;
    svgBlack = KING_BLACK;

    positionsUnderAttack(board) {
        let result = [
            [this.posX - 1, this.posY - 1],
            [this.posX - 1, this.posY],
            [this.posX - 1, this.posY + 1],
            [this.posX, this.posY - 1],
            [this.posX, this.posY + 1],
            [this.posX + 1, this.posY - 1],
            [this.posX + 1, this.posY],
            [this.posX + 1, this.posY + 1]
        ];
        result = result.filter(pos => {
            return pos[0] >= 0 && pos[0] < board.scaleX && pos[1] >= 0 && pos[1] < board.scaleY
        });
        return result;
    }

    availablePositions(board) {
        let result = this.positionsUnderAttack(board);
        result = result.filter(pos => {
            const piece = board.getPiece(pos[0], pos[1]);
            return !piece || piece.player !== this.player
        });
        result = result.filter(pos => {
            return !this.isCheckAfterMove(board, pos)
        });
        board.availableCastlings(this.player).forEach(castling => result.push(castling.mainMove));
        return result;
    }

    beforeMove(board, x, y) {
        const castlings = board.availableCastlings(this.player);
        castlings.forEach(castling => {
            if (castling.mainMove[0] === x && castling.mainMove[1] === y) {
                castling.castle.posX = castling.castleMove[0];
                castling.castle.posY = castling.castleMove[1];
            }
        });
        super.beforeMove(board, x, y);
    }

    clone() {
        const result = new King();
        super.clone(result);
        return result;
    }
}